import * as monaco from "monaco-editor";

import { RepoFile } from "types/generated";

import { LINE_HEIGHT, MAX_EDITOR_HEIGHT, PADDING } from "./constants";

export type CommitTreeNode = {
  id: string;
  parentId: string | undefined;
  name: string;
};

export const buildTreeNodes = (files: RepoFile[]): CommitTreeNode[] => {
  const folderSet = new Set<string>();
  const nodes: CommitTreeNode[] = [];

  for (const file of files) {
    const segments = file.filePath.split("/");

    for (let i = 0; i < segments.length - 1; i++) {
      const folderId = segments.slice(0, i + 1).join("/");

      if (!folderSet.has(folderId)) {
        folderSet.add(folderId);
        nodes.push({
          id: folderId,
          parentId: i === 0 ? undefined : segments.slice(0, i).join("/"),
          name: segments[i],
        });
      }
    }

    nodes.push({
      id: file.filePath,
      parentId: segments.length > 1 ? segments.slice(0, -1).join("/") : undefined,
      name: segments[segments.length - 1],
    });
  }

  return nodes;
};

export const computeDiffCounts = (changes: monaco.editor.ILineChange[]) => {
  let additions = 0;
  let deletions = 0;

  for (const change of changes) {
    if (change.modifiedEndLineNumber > 0) {
      additions += change.modifiedEndLineNumber - change.modifiedStartLineNumber + 1;
    }
    if (change.originalEndLineNumber > 0) {
      deletions += change.originalEndLineNumber - change.originalStartLineNumber + 1;
    }
  }

  return { additions, deletions };
};

export const getEditorHeight = (original: string, modified: string) => {
  const originalLines = original.split("\n").length;
  const modifiedLines = modified.split("\n").length;
  const totalLines = originalLines + modifiedLines;

  return Math.min(totalLines * LINE_HEIGHT + PADDING, MAX_EDITOR_HEIGHT);
};
